__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "minhasturmas-mfe-consumer";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(11), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(31000))))));
			register("@plurall/elo-v3", "0.15.1", () => (Promise.all([__webpack_require__.e(200), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(12200))))));
			register("@plurall/use-person-assistent", "1.0.9", () => (__webpack_require__.e(764).then(() => (() => (__webpack_require__(13764))))));
			register("@sentry/browser", "7.120.4", () => (__webpack_require__.e(369).then(() => (() => (__webpack_require__(34369))))));
			register("@sentry/browser", "8.55.2", () => (Promise.all([__webpack_require__.e(77), __webpack_require__.e(818)]).then(() => (() => (__webpack_require__(1818))))));
			register("@sentry/react", "8.55.2", () => (Promise.all([__webpack_require__.e(77), __webpack_require__.e(868), __webpack_require__.e(318), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(82868))))));
			register("@stitches/react", "1.2.8", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(345)]).then(() => (() => (__webpack_require__(33345))))));
			register("ckeditor4-react", "4.3.0", () => (Promise.all([__webpack_require__.e(136), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(41136))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(26710))))));
			register("graphql-tag", "2.12.7", () => (Promise.all([__webpack_require__.e(357), __webpack_require__.e(516)]).then(() => (() => (__webpack_require__(2135))))));
			register("graphql", "16.14.2", () => (__webpack_require__.e(547).then(() => (() => (__webpack_require__(91547))))));
			register("optimism", "0.18.1", () => (__webpack_require__.e(220).then(() => (() => (__webpack_require__(6839))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(86663))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(78087);
			initExternal(47502);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};